import React from "react";

function ToggleArrow({ className }: { className: string }) {
  return (
    <svg className={className} viewBox="-0.75 3.7 13.05 15.2">
      <path d="M6.391,17.944,11.3,13.033a.863.863,0,0,0,0-1.224l-.816-.816a.863.863,0,0,0-1.224,0L5.777,14.47,2.3,10.989a.863.863,0,0,0-1.224,0l-.82.816a.863.863,0,0,0,0,1.224L5.163,17.94A.864.864,0,0,0,6.391,17.944Z" />
      <path
        d="M6.391,17.944l3.5-3.5L11.3,13.033a.863.863,0,0,0,0-1.224l-.816-.816a.863.863,0,0,0-1.224,0L5.777,14.47,2.3,10.989a.863.863,0,0,0-1.224,0l-.82.816a.863.863,0,0,0,0,1.224L5.163,17.94A.864.864,0,0,0,6.391,17.944Z"
        transform="translate(0 -6.306)"
      />
    </svg>
  );
}

export { ToggleArrow };
